"use client";

import React, { useEffect } from "react";
import Breadcrumbs, { BreadcrumbOptionsInterface } from "@/components/Breadcrumbs";
import styles from "@/components/VideoPage/video.module.scss";
import routes from "@/helpers/router";
import { useSyncVideoData } from "@/components/VideoPage/syncVideoData";
import VideoComponentMapping from "@/components/VideoPage/videoComponentMapping";
import signedInStateSelector from "@/redux/slice/auth/selectors/signedInState";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { NON_ONBOARDED_STATUS, ONBOARDING_STATUS } from "@/helpers/constants";
import SegmentInfoSelector from "@/redux/slice/auth/selectors/userSegmentInfo";
import { SignedinState } from "@/redux/slice/auth/enums/SignedInState";
import { pageViewEvent } from "@/helpers/TSDEvents";
import { setReferer } from "@/redux/slice/global/slice";

const VideoPage = ({ videoData, ua, referer, slug, currentSpeciality, doctorsArray, diagnosticsArray }) => {
  const videoInfoObject = videoData;
  const dispatch = useAppDispatch();
  useSyncVideoData({ VideoData: videoInfoObject, ua, slug });
  const signedInStatus = useAppSelector(signedInStateSelector);
  const SegmentInfoObject = useAppSelector(SegmentInfoSelector);

  const extras: any = {
    currentSpeciality,
    doctorsArray,
    diagnosticsArray,
  };

  const generateBreadcrumbs = () => {
    const videoDetail = videoInfoObject?.data?.[0]?.attributes;
    const breadCrumbs: [BreadcrumbOptionsInterface] = [
      {
        label: videoDetail?.Category?.data?.attributes?.CategoryName,
        url: routes.category(videoDetail?.Category?.data?.attributes?.Slug),
      },
    ];

    if (videoDetail?.Pillar) {
      const pillarName = videoDetail?.Pillar?.data?.attributes?.Name;
      breadCrumbs.push({
        label: pillarName,
        url: routes.pillar(videoDetail?.Pillar?.data?.attributes?.Slug),
      });
    }

    if (videoDetail?.Cluster) {
      const clusterName = videoDetail?.Cluster?.data?.attributes?.Name;
      breadCrumbs.push({
        label: clusterName,
        url: routes.cluster(videoDetail?.Cluster?.data?.attributes?.Slug),
      });
    }

    breadCrumbs.push({
      label: videoDetail?.Title,
      url: routes.video(videoDetail?.Slug),
    });

    return breadCrumbs;
  };

  const breadCrumbsArray: [BreadcrumbOptionsInterface] = generateBreadcrumbs();
  const videoSections = videoInfoObject?.data?.[0]?.attributes?.VideoContent;

  const leftPanelSections = videoSections?.filter(
    (section: any) => section?.Position !== "Right" && section?.Position !== "Bottom"
  );
  const rightPanelSections = videoSections?.filter((section: any) => section?.Position === "Right");
  const fullWidthSections = videoSections?.filter((section: any) => section?.Position === "Bottom");
  const fullWidthComponentTypes = fullWidthSections?.map((section: any) => section.ComponentType);

  useEffect(() => {
    dispatch(setReferer(referer));

    if (signedInStatus !== SignedinState.UNRESOLVED) {
      const isUserLoggedin = signedInStatus === SignedinState.SIGNEDIN;

      pageViewEvent({
        page: "video",
        page_name: "Video Page",
        is_loggedin: isUserLoggedin ? true : false,
        momverse_stage: SegmentInfoObject?.type
          ? (ONBOARDING_STATUS[SegmentInfoObject?.type] ?? "")
          : NON_ONBOARDED_STATUS,
        type: "video",
        nav_src: referer || "direct",
      });
    }
  }, [signedInStatus]);

  return (
    <>
      <div className={`${styles.breadcrumb} container ${styles.videoPageRoot}`}>
        <Breadcrumbs options={breadCrumbsArray} />
      </div>
      {ua?.isMobile && (
        <div className={`${styles.videoinsideSection}`}>
          <>
            {videoSections?.map((section: any, index: number) => {
              return (
                <React.Fragment key={index}>
                  <div
                    className={`${fullWidthComponentTypes?.includes(section.ComponentType) ? `` : `container ${styles.videoPageRoot}`}`}
                  >
                    <VideoComponentMapping data={section} extras={extras} />
                  </div>
                </React.Fragment>
              );
            })}
          </>
        </div>
      )}

      {ua?.isDesktop && (
        <>
          <div className={`${styles.columnsContainer} container ${styles.videoPageRoot}`}>
            <div className={styles.leftSection}>
              {leftPanelSections?.map((section: any, index: number) => {
                return (
                  <React.Fragment key={index}>
                    <VideoComponentMapping data={section} extras={extras} />
                  </React.Fragment>
                );
              })}
            </div>
            <div className={styles.rightSection}>
              {rightPanelSections?.map((section: any, index: number) => {
                return (
                  <React.Fragment key={index}>
                    <VideoComponentMapping data={section} extras={extras} />
                  </React.Fragment>
                );
              })}
            </div>
          </div>
          <div>
            {fullWidthSections?.map((section: any, index: number) => {
              return (
                <React.Fragment key={index}>
                  <VideoComponentMapping data={section} extras={extras} />
                </React.Fragment>
              );
            })}
          </div>
        </>
      )}
    </>
  );
};

export default VideoPage;
